export const removeSvgFocusIE = () => {
  const ua = window.navigator.userAgent;
  const isIE = /MSIE|Trident/.test(ua);

  if (isIE) {
    const svgs = document.getElementsByTagName("svg");

    let i = svgs.length;

    while (i--) {
      svgs[i].setAttribute("focusable", "false");
    }
  }
};
